module.exports = __webpack_public_path__ + "img/theroom_amp0.b9e471d5.jpg";